import Vue from 'vue';
import { $http } from '@/utils/https'
import store from '@/store'
import {
    SET_LOADING_PROPS_SELECTION,
    SET_PROPS_SELECTION,
    UPDATE_CHECKED_LIST_IN_PROPS,
    PROPS_SELECTION_CHANGE_SKIP,
    PROPS_SELECTION_SET_COUNT,
    SET_COUNT_PRODUCTS,
    CHECK_COUNT_PRODUCTS_LOADING,
    SET_ALL_FILTERS,
    GET_ALL_FILTERS_LOADING,
    PROPS_SELECTION_RESET_ALL,
    PROPS_SELECTION_CHANGE_RESET_ALL,
    PROPS_SELECTION_CHANGE_PRICE
} from '../mutation-types';
import _ from 'lodash'
import {
    GET_PROPS_SELECTION,
    CHECK_COUNT_PRODUCTS,
    GET_ALL_FILTERS
} from '../action-types';


const state = {
    countProducts: 0,
    countProductsLoading: false,

    list: null,
    listLoading: false,
    checkedList: [],
    skip: 0,
    count: 0,
    limit: 12,
    filters: null,
    filtersLoading: false,
    isResetAll: false,
    price: {
        min: '',
        max: ''
    }
};

const getters = {
    price: state => state.price,
    isResetAll: state => state.isResetAll,

    filters: state => state.filters,
    filtersLoading: state => state.filtersLoading,

    countProducts: state => state.countProducts,
    countProductsLoading: state => state.countProductsLoading,

    list: state => state.list,
    skip: state => state.skip,
    count: state => state.count,
    limit: state => state.limit,
    listLoading: state => state.listLoading,
    checkedList: state => state.checkedList,
};

const actions = {
    [GET_PROPS_SELECTION]: async ({ commit }, payload) => {
        commit(SET_LOADING_PROPS_SELECTION, true);
        try {
            const response = await $http.post(`v1/category/products?limit=${state.limit}&skip=${state.skip}`, payload);
            commit(SET_PROPS_SELECTION, response.data.data);
            commit(PROPS_SELECTION_SET_COUNT, response.data.meta.count);
        }catch (e) {
            throw e;
        }finally {
            commit(SET_LOADING_PROPS_SELECTION, false);
        }
    },
    [CHECK_COUNT_PRODUCTS]: async ({ commit }, payload) => {
        commit(CHECK_COUNT_PRODUCTS_LOADING, true);
        try {
            const response = await $http.post(`v1/category/products/count`, payload);
            commit(SET_COUNT_PRODUCTS, response.data.count);
        }catch (e) {
            throw e;
        }finally {
            commit(CHECK_COUNT_PRODUCTS_LOADING, false);
        }
    },
    [GET_ALL_FILTERS]: async ({ commit }) => {
        commit(GET_ALL_FILTERS_LOADING, true);
        try {
            const response = await $http.get(`v1/filter`);
            commit(SET_ALL_FILTERS, response.data.data);
        }catch (e) {
            throw e;
        }finally {
            commit(GET_ALL_FILTERS_LOADING, false);
        }
    },
};

const mutations = {
    [SET_PROPS_SELECTION](state, list) {
        state.list = list;
    },
    [PROPS_SELECTION_CHANGE_RESET_ALL](state, status) {
        state.isResetAll = status;
    },
    [SET_LOADING_PROPS_SELECTION](state, status) {
        state.listLoading = status;
    },
    [SET_COUNT_PRODUCTS](state, count) {
        state.countProducts = count;
    },
    [SET_ALL_FILTERS](state, data) {
        state.filters = data;

        // add category list
        const obj = {
            slug: 'category',
            name: '',
            values: {
                data : []
            }
        }
        store.state.setting.menu.forEach(e => {
            const item = {
                slug: e.slug,
                value: e.name
            };
            obj.values.data.push(item);
        });
        state.filters.unshift(obj)
    },
    [CHECK_COUNT_PRODUCTS_LOADING](state, status) {
        state.countProductsLoading = status;
    },
    [GET_ALL_FILTERS_LOADING](state, status) {
        state.filtersLoading = status;
    },
    [PROPS_SELECTION_CHANGE_SKIP](state, skip) {
        state.skip = skip;
    },
    [PROPS_SELECTION_RESET_ALL](state) {
        state.checkedList = [];
        state.countProducts = 0;
        state.skip = 0;
        state.list = null;
        setTimeout(() => { state.isResetAll = false }, 100)
    },
    [PROPS_SELECTION_SET_COUNT](state, count) {
        state.count = count;
    },
    [PROPS_SELECTION_CHANGE_PRICE](state, params) {
        state.price = params;
    },
    [UPDATE_CHECKED_LIST_IN_PROPS](state, data) {
        const elem = _.find(state.checkedList, ['slug', data.slug]);
        if(elem){
            if(elem.categories.length !== 0){
                const index = _.findIndex(state.checkedList, e => e.slug === data.slug);
                Vue.set(state.checkedList, index, data);

                if(state.checkedList[index].categories.length === 0){
                    _.remove(state.checkedList, e => e.slug === data.slug);
                }
            }
        }else{
            state.checkedList.push(data);
        }
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
